// Copyright (c) Zammo Inc.
import styled, { css } from 'styled-components';

import { palette } from '../../styles/variables';

interface Props {
  disabled?: boolean;
}

export const buttonStyles = css<Props>`
  border: none;
  background: ${(props) => (props.disabled ? palette.gray : palette.blue)};
  color: white;
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: -0.2px;
  padding: 0.5rem 2em;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: ${(props) => (props.disabled ? palette.gray : palette.darkBlue)};
  }
`;

export default styled.button`
  ${buttonStyles};
`;
